import '../scss/styles.scss';
import accordion from './../../winstongolf.de/js/module/accordion'
import navigation from './../../winstongolf.de/js/module/navigation'
// import cookiebanner from './../../winstongolf.de/js/module/cookiebanner'
import accordionLight from './../../winstongolf.de/js/module/_accordion_light'
import carousel from './../../winstongolf.de/js/module/carousel'
import custom from './../../winstongolf.de/js/module/custom'
import aos from './../../winstongolf.de/js/module/aos'
import topbutton from './../../winstongolf.de/js/module/top-button'
import comfort from './../../winstongolf.de/js/module/comfort';
import './../../winstongolf.de/js/module/datepicker';
import './../../winstongolf.de/js/module/smoobu'
